const {Component} = require("react");
const Navbar = require("components/checkout/Navbar");
const store = require("stores/OrderStore");
const router = require("services/router");
const {moneyFormat} = require("helpers/format");
const {decodeObservable} = require("helpers/object");

class ReceiptNav extends Component {

	get usedVoucher() {
		return store.attributes.voucher_id ? true : false;
	}

	get payedExtra() {
		return store.attributes.unit_price_extra > 0;
	}

	get purchasedVoucher() {
		return store.attributes.created_voucher;
	}

	get voucher() {
		if (!this.usedVoucher) return 0;

		return store.attributes.voucher;
	}

	get voucherPrice() {
		if (!this.usedVoucher) return 0;

		return this.voucher.full_price;
	}

	onNavSubmit = () => {
		window.location = router.route("backend.bookings");
	};

	processTotal = (total) => {
		total = !this.purchasedVoucher && this.usedVoucher ?
			0 :
			total;

		total = this.purchasedVoucher ?
			this.voucherPrice :
			total;

		// recipient costs
		total += this.total_unit_price_extra;

		// fee
		total = this.usedVoucher ?
			total :
			total + (this.hours * parseFloat(store.attributes.unit_price_fee));

		return total;
	};

	get hours(){
		let hours = 0;
		let bookings = decodeObservable(store.attributes.bookings);
        if(bookings.length > 0){
            for(let booking_index in bookings){
            	let booking = store.attributes.bookings[booking_index];
            	hours += booking.hours;
			}
		}
		return hours;
	}

	get total_unit_price_extra(){
        const unitPriceExtra = parseFloat(store.attributes.unit_price_extra);
		return this.hours * unitPriceExtra;
	}

	renderRecipientCosts() {

		if (this.total_unit_price_extra > 0) {
			const amount = this.total_unit_price_extra;

			return (
				<div className="class-row">
					<p>Tillæg ved mere end 1 elev</p>
					<p className="price">{moneyFormat(amount)}</p>
				</div>
			);
		}
	}

	renderVoucher = () => {
		if (!this.usedVoucher || (!this.payedExtra && !this.purchasedVoucher)) return;

		let voucherPrice = null;

		if (this.purchasedVoucher) {
			const base = this.voucher.unit_price * this.voucher.original_clips;
			const fee = this.voucher.full_price - base;

			voucherPrice = (
				<React.Fragment>
					<div className="class-row">
						<p>Klippekort:</p>
						<p className="price">{moneyFormat(base)}</p>
					</div>
					<div className="class-row">
						<p>Servicegebyr:</p>
						<p className="price">{moneyFormat(fee)}</p>
					</div>
				</React.Fragment>
			);
		}

		return (
			<div className="classes">
				<div className="payment-extras">
					{voucherPrice}
					{this.renderRecipientCosts()}
				</div>
			</div>
		);
	}

	renderFee() {
		const amount = store.attributes.bookings.length * parseFloat(store.attributes.unit_price_fee);

		return (
			<div className="class-row">
				<p>Servicegebyr</p>
				<p className="price">{moneyFormat(amount)}</p>
			</div>
		);
	}

	renderExtras = () => {
		return (
			<div className="payment-nav-extras">
				{this.renderRecipientCosts()}
				{this.renderFee()}
			</div>
		)
	};

	render() {
		return (
			<Navbar store={store} submitLabel="Gå til kontrolpanelet" handleSubmit={this.onNavSubmit}
							showClips={this.usedVoucher}
							clipsLeft={store.attributes.voucher ? store.attributes.voucher.clips : null}
							renderVoucher={this.renderVoucher}
							processTotal={this.processTotal}
							renderExtras={this.renderExtras}/>
		);
	}

}

module.exports = ReceiptNav;



// WEBPACK FOOTER //
// ./resources/js/components/checkout/ReceiptNav.js